module.exports = "<div class=\"wrapper_box\">\n  <ng2-slim-loading-bar [color]=\"'red'\" [height]=\"'4px'\"></ng2-slim-loading-bar>\n  <simple-notifications [options]=\"options\"></simple-notifications>\n  <app-header></app-header>\n  <router-outlet></router-outlet>\n  <app-footer></app-footer>\n</div>\n<!-- Wrapper Box End -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 635
// module chunks = 0